module.exports = __webpack_public_path__ + "static/halfling-lightfoot-female-shandie-AYAGWW-ee84ba1d8f31ecbd6be6718665d2af2b.png";